/**
 * User utility functions for consistent persona determination across the app.
 */

/**
 * Determines if a user is external (customer) based on user data.
 *
 * @param {Object} user - User object from backend
 * @param {boolean} user.is_internal - Backend property indicating internal user
 * @returns {boolean} True if user is external/customer, false if internal/admin
 */
export const isExternalUser = (user) => {
  if (!user || user.is_internal == null) return false;
  return !user.is_internal;
};

/**
 * Gets the appropriate home path for a user based on their persona.
 *
 * @param {Object} user - User object from backend
 * @returns {string} Home path for the user's persona
 */
export const getUserHomePath = (user) => {
  return isExternalUser(user) ? '/enduser/home' : '/admin/home';
};
